export default "__VITE_ASSET__Co4hNstv__"